export default __webpack_public_path__ + "static/media/ye-jawaani-hai-deewani.21a2dc43.jpg";